module.exports = __webpack_public_path__ + "assets/fd09ca7ea9af078c11e1f38d9cad6bef.png";